import fs from 'fs';
import { join, resolve } from 'pathe';
import type { NuxtRuntimeConfig } from '@nuxt/bridge-schema';

export async function contentDataFor(
  path: string,
  config: NuxtRuntimeConfig | undefined = undefined
) {
  // On server-side, we can load the file directly.
  if (process.server) {
    const realPath = resolve(join('public/content/content-json', path));
    try {
      const data = fs.readFileSync(realPath, 'utf8');
      return JSON.parse(data);
    } catch (error: Error | any) {
      const message = `[Lib] contentdata file not found: "${realPath}" (${error.message})`;
      console.error(message);
      return {};
    }
  }
  const publicConfig = config?.public || config;
  if (!publicConfig) {
    console.error("You'll have to provide a config.");
    return {};
  }

  // on client side we have to request the file
  try {
    const response = await fetch(
      `${
        publicConfig.cloudFront?.contentDataEnabled ? publicConfig.cdnUrl : ''
      }/content/content-json/${path}`
    ).then((r) => r.json());
    return response || {};
  } catch (error: Error | any) {
    const isProduction = config.public?.mode?.isProduction || config.mode?.isProduction;
    if (!isProduction) {
      console.error(error);
    }
    return {};
  }
}
